import { Measure } from 'services/model/model.service';
import { isRecentlyChangedMeasure } from './recentlyChangedMeasures';

export interface MeasureKpiEntry {
  kind: 'measure';
  key: string;
  measure: Measure;
  isOrderDate?: boolean;
}

export interface CustomKpiEntry {
  kind: 'custom';
  key: string;
  titleId?: string;
  title?: string;
  descriptionId?: string;
  description?: string;
  measure?: Measure;
}

export type InfoDrawerKpiEntry = MeasureKpiEntry | CustomKpiEntry;

export function measureKpi(measure: Measure, options: { isOrderDate?: boolean } = {}): MeasureKpiEntry {
  return { kind: 'measure', key: measure.code, measure, isOrderDate: options.isOrderDate };
}

export function customKpi(
  key: string,
  content: Pick<CustomKpiEntry, 'titleId' | 'title' | 'descriptionId' | 'description' | 'measure'>
): CustomKpiEntry {
  return { kind: 'custom', key, ...content };
}

export function measureCustomKpi(key: string, measure: Measure, translationBase: string): CustomKpiEntry {
  return customKpi(key, {
    titleId: `${translationBase}.name`,
    descriptionId: `${translationBase}.description`,
    measure,
  });
}

export function splitInfoDrawerKpiEntries(kpis: InfoDrawerKpiEntry[]): {
  recentlyChangedEntries: InfoDrawerKpiEntry[];
  kpiEntries: InfoDrawerKpiEntry[];
} {
  const recentlyChangedEntries: InfoDrawerKpiEntry[] = [];
  const kpiEntries: InfoDrawerKpiEntry[] = [];

  kpis.forEach(entry => {
    if (entry.measure && isRecentlyChangedMeasure(entry.measure)) {
      recentlyChangedEntries.push(entry);
      return;
    }

    kpiEntries.push(entry);
  });

  return { recentlyChangedEntries, kpiEntries };
}
